export type MatrixSession = {
  accessToken: string
  userId: string
  deviceId?: string
}

type MatrixConfig = {
  homeserverUrl?: string
}

const KEY_SESSION = 'matrix:session:v1'
const KEY_CONFIG = 'matrix:config:v1'

// legacy keys qu'on a déjà vus passer
const LEGACY_SESSION_KEYS = ['sparker_matrix_session', 'matrix:session', 'matrix_session']

function safeGet(key: string): string | null {
  try {
    return window?.localStorage?.getItem?.(key) ?? null
  } catch {
    return null
  }
}

function safeSet(key: string, value: string) {
  try {
    window?.localStorage?.setItem?.(key, value)
  } catch {}
}

function safeRemove(key: string) {
  try {
    window?.localStorage?.removeItem?.(key)
  } catch {}
}

function normalizeSession(obj: any): MatrixSession | null {
  if (!obj) return null
  const accessToken =
    obj.accessToken ??
    obj.access_token ??
    obj?.session?.accessToken ??
    obj?.session?.access_token
  const userId = obj.userId ?? obj.user_id ?? obj?.session?.userId ?? obj?.session?.user_id
  const deviceId =
    obj.deviceId ?? obj.device_id ?? obj?.session?.deviceId ?? obj?.session?.device_id

  if (!accessToken || !userId) return null
  return {accessToken, userId, deviceId}
}

export async function loadMatrixSession(): Promise<MatrixSession | null> {
  // 1) clé officielle
  const raw = safeGet(KEY_SESSION)
  if (raw) {
    try {
      return normalizeSession(JSON.parse(raw))
    } catch {}
  }

  // 2) migration legacy -> officielle
  for (const k of LEGACY_SESSION_KEYS) {
    const legacyRaw = safeGet(k)
    if (!legacyRaw) continue
    try {
      const migrated = normalizeSession(JSON.parse(legacyRaw))
      if (migrated) {
        await saveMatrixSession(migrated)
        safeRemove(k)
        return migrated
      }
    } catch {}
  }

  return null
}

export async function saveMatrixSession(session: MatrixSession): Promise<void> {
  const normalized = normalizeSession(session)
  if (!normalized) return
  safeSet(KEY_SESSION, JSON.stringify(normalized))
}

export async function clearMatrixSession(): Promise<void> {
  safeRemove(KEY_SESSION)
  for (const k of LEGACY_SESSION_KEYS) safeRemove(k)
}

export async function loadMatrixConfig(): Promise<MatrixConfig | null> {
  const raw = safeGet(KEY_CONFIG)
  if (!raw) return null
  try {
    return JSON.parse(raw) as MatrixConfig
  } catch {
    return null
  }
}

export async function saveMatrixConfig(config: MatrixConfig): Promise<void> {
  safeSet(KEY_CONFIG, JSON.stringify(config ?? {}))
}
